// Sentry initialisation must run before any other module so it can
// install global error handlers as early as possible.
import "@/sentry";
import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";
import { registerPwa } from "@/utils/pwa";

const errorFallback = (
  <div style={{
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#1A1A1A",
    color: "#FAFAFA",
    fontFamily: "Manrope, system-ui, sans-serif",
    padding: "2rem",
    textAlign: "center",
  }}>
    <div style={{ maxWidth: 480 }}>
      <p style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: "2rem",
        marginBottom: "0.75rem",
      }}>Something has come unstuck.</p>
      <p style={{ color: "#9ca3af", fontSize: "0.95rem", marginBottom: "1.5rem" }}>
        Our team has been notified. Refresh the page or head back to the homepage to try again.
      </p>
      <a href="/" style={{
        color: "#D4AF37",
        textDecoration: "underline",
        textUnderlineOffset: "4px",
      }}>Back to Zuriya</a>
    </div>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={errorFallback}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

registerPwa();
